const main = () => {
    const el = document.getElementById("js-countdown");
    if (!el) return;

    let seconds = parseInt(el.textContent, 10);
    if (Number.isNaN(seconds) || seconds <= 0) return;

    const timer = setInterval(() => {
        seconds -= 1;
        if (seconds <= 0) {
            clearInterval(timer);
            seconds = 0;
        }
        el.textContent = seconds;
    }, 1000);
};

export default main;
